import { render } from 'react-dom';
import { ConfigProvider } from 'antd';
import App from './App';

render(
  <ConfigProvider theme={{ hashed: false, token: { colorPrimary: '#1998d5' } }}>
    <App />
  </ConfigProvider>,
  document.querySelector('#app'),
);
